import { PageHeader, usePageHeader } from '@easydoctor/ui';
import Stack from '@mui/material/Stack';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { Link, Outlet, useLocation } from 'react-router';
import { HelpButton } from '../../guida/HelpButton';
import { SETTINGS_SECTIONS } from './sections';

/** Cornice delle Impostazioni (PRD-002, PRD-003, PRD-004): titolo, sezioni a schede, contenuto. */
export function ImpostazioniLayout() {
  const { pathname } = useLocation();
  const section = SETTINGS_SECTIONS.find(({ path }) => pathname.startsWith(path));
  const current = section?.path ?? false;
  usePageHeader({ title: section ? `${section.label} · Impostazioni` : 'Impostazioni' });

  return (
    <Stack spacing={4}>
      <PageHeader
        title="Impostazioni"
        // Il «?» segue la sezione aperta: ognuna ha le sue pagine nella Guida.
        titleAdornment={current && <HelpButton key={current} screen={current} />}
        description="Quello che cambia senza passare dallo sviluppo. Le modifiche valgono per le segnalazioni successive."
      />
      <Tabs value={current} aria-label="Sezioni delle impostazioni">
        {SETTINGS_SECTIONS.map((section) => (
          <Tab key={section.path} value={section.path} label={section.label} component={Link} to={section.path} />
        ))}
      </Tabs>
      <Outlet />
    </Stack>
  );
}
